import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import {
    defaultResource,
    Resource,
    resourceFromAttributes,
} from '@opentelemetry/resources';
import {
    BatchSpanProcessor,
    InMemorySpanExporter,
    WebTracerProvider,
} from '@opentelemetry/sdk-trace-web';
import {
    ATTR_SERVICE_NAME,
    ATTR_SERVICE_VERSION,
} from '@opentelemetry/semantic-conventions';

import { ServiceInfo } from './interfaces/service-info.interface';

export const mainFrontendName = 'mis-frontend';

export class Telemetry {
    public static init(serviceInfo?: ServiceInfo): void {
        registerInstrumentations({
            instrumentations: [
                getWebAutoInstrumentations({
                    '@opentelemetry/instrumentation-document-load': {},
                    '@opentelemetry/instrumentation-user-interaction': {},
                    '@opentelemetry/instrumentation-fetch': {},
                    '@opentelemetry/instrumentation-xml-http-request': {},
                }),
            ],
        });

        const resource = Telemetry.createResource(serviceInfo);
        const exporter = new InMemorySpanExporter();
        const processor = new BatchSpanProcessor(exporter);
        const provider = new WebTracerProvider({
            resource,
            spanProcessors: [processor],
        });

        //Todo MIS-22398 Автоинструментировать фронтовое приложение
        // new OTLPTraceExporter({
        //     url: 'http://localhost:9500/v1/traces', // эта урла проксируется конфигом ниже в otel-collector
        // }),

        provider.register();
    }

    private static createResource(serviceInfo?: ServiceInfo): Resource {
        const serviceName = serviceInfo
            ? serviceInfo.servicePrefix
            : mainFrontendName;
        const serviceVersion = serviceInfo
            ? serviceInfo.version.version
            : 'LOCAL';

        return defaultResource().merge(
            resourceFromAttributes({
                [ATTR_SERVICE_NAME]: serviceName,
                [ATTR_SERVICE_VERSION]: serviceVersion,
            }),
        );
    }
}
